/* eslint-disable import/no-cycle */
import axios from 'axios';

import { getToken, refreshAccessToken } from '../services/authentication/auth';
import { RotasNaoProtegidas } from '../components/Shared/Enums/RotasNaoProtegidas';

const api = axios.create({ baseURL: `${process.env.REACT_APP_API_CADASTRO_BASE_URL}` });

const verificaSeExisteRotaNaoAutenticada = rota => {
  let retorno = false;
  RotasNaoProtegidas.map(rotas => {
    if (rota.toLowerCase().indexOf(rotas) >= 0) {
      retorno = true;
    }
    return rotas;
  });
  return retorno;
};

api.interceptors.request.use(
  config => {
    const { url } = config;
    const token = getToken();

    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    } else if (!verificaSeExisteRotaNaoAutenticada(url)) {
      // eslint-disable-next-line no-console
      console.error('rota desprotegida', url);
      window.location.replace('/force-logout');
      return config;
    }

    return config;
  },
  error => Promise.reject(error)
);

// refreshAccessToken vem de services/authentication/auth.js — evita duplicar
// a implementacao com um endpoint diferente (essa versao local chamava
// {REACT_APP_API_CADASTRO_BASE_URL}/login, que nao existe; o endpoint real de
// refresh e REACT_APP_LOGIN, usado pela versao compartilhada).
const refreshAndRetryQueue = [];

let isRefreshing = false;

api.interceptors.response.use(
  response => response,
  async error => {
    const originalRequest = error.config;

    // Um 401 vindo das proprias rotas de autenticacao (login, confirmacao,
    // recuperacao de senha) significa credencial invalida -- nao token expirado.
    // Tentar renovar nesse caso dispara refreshAccessToken sem refresh_token
    // valido, que por sua vez redireciona para /force-logout: o usuario e
    // deslogado no exato momento em que tenta entrar.
    const ehRotaDeAutenticacao = verificaSeExisteRotaNaoAutenticada(originalRequest?.url ?? '');

    if (error.response && error.response.status === 401 && !ehRotaDeAutenticacao) {
      if (!isRefreshing) {
        isRefreshing = true;
        try {
          const newAccessToken = await refreshAccessToken();
          error.config.headers['Authorization'] = `Bearer ${newAccessToken}`;

          refreshAndRetryQueue.forEach(({ config, resolve, reject }) => {
            api
              .request(config)
              .then(response => resolve(response))
              .catch(err => reject(err));
          });
          refreshAndRetryQueue.length = 0;

          return api(originalRequest);
        } catch (refreshError) {
          // eslint-disable-next-line no-console
          console.error('refreshAccessToken', refreshError);
          window.location.replace('/force-logout');
          return Promise.reject();
        } finally {
          isRefreshing = false;
        }
      }
      return new Promise((resolve, reject) => {
        refreshAndRetryQueue.push({ config: originalRequest, resolve, reject });
      });
    }
    return Promise.reject(error);
  }
);

export default api;
